import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { ItemCategory } from "../model/item-category.model";
import { LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { StockInWebKind, TaxServiceApplyType } from "../model/item.model";
import { take } from "rxjs/operators";
import { form_control, Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { SoftWareLicenseKind } from "projects/sepidz-web-framework/src/lib/models/license-information.model";
import { ItemCategorySelectFormComponent } from "./item-category-select-form/item-category-select-form.component";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";

@Component({
  selector: "ngx-item-category-form",
  templateUrl: "./item-category-form.component.html",
  styleUrls: ["./item-category-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemCategoryFormComponent extends BaseFormComponent<ItemCategory> {
  haserror: boolean = false;
  erroremessage: string;
  deactivateSave: boolean = false;
  constructor(private lookupService: LookupService, protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.FillData();
  }

  async ngOnInit() {
    this.apiName = "ItemCategory";
    this.label = this.translate("ClientApp.FrontOffice.Catalog.ItemCategory.ItemCategory");
    super.ngOnInit();
  }

  public openImagesForm() {
    this.dialogService
      .open(ItemCategorySelectFormComponent, { image: this.model.Image }, { autoFocus: true, closeOnClickOutside: false })
      .pipe(take(1))
      .subscribe((res) => {
        this.model.Image = res;
        this.setValue("Image", res);
      });
  }

  setdefault() {
    this.selectorService.setHasDefaultValue("ParentId", false);
    this.model.StockInWeb = StockInWebKind.Available;
    if (!this.model.TaxApplyTypeId) {
      this.lookupService
        .getLookupbyCode("SALE", "TaxServiceApplyType", TaxServiceApplyType.NotApply)
        .pipe(take(1))
        .subscribe(async (x) => {
          this.model.TaxApplyTypeId = x.Id;
          this.model.TaxApplyTypeCode = x.Code;
          this.model.TaxApplyTypeTitle = x.Title;
          this.setValue("TaxApplyTypeId", x.Id);
          this.setValue("TaxApplyTypeCode", x.Code);
          this.setValue("TaxApplyTypeTitle", x.Title);
        });
    }
    if (!this.model.ServiceApplyTypeId) {
      this.lookupService
        .getLookupbyCode("SALE", "TaxServiceApplyType", TaxServiceApplyType.NotApply)
        .pipe(take(1))
        .subscribe(async (x) => {
          this.model.ServiceApplyTypeId = x.Id;
          this.model.ServiceApplyTypeCode = x.Code;
          this.model.ServiceApplyTypeTitle = x.Title;
          this.setValue("ServiceApplyTypeId", x.Id);
          this.setValue("ServiceApplyTypeCode", x.Code);
          this.setValue("ServiceApplyTypeTitle", x.Title);
        });
    }
    super.setdefault();
  }
  onChange($event: Lookup) {
    if ($event && $event.Category) {
      if (this.model.TaxApplyTypeId === $event.Id) {
        this.model.TaxApplyTypeCode = $event.Code;
        this.model.TaxApplyTypeTitle = $event.Title;
      }
      if (this.model.ServiceApplyTypeId === $event.Id) {
        this.model.ServiceApplyTypeCode = $event.Code;
        this.model.ServiceApplyTypeTitle = $event.Title;
      }
    }
  }
  addControl() {
    this.cd.markForCheck();
  }
  beforupdate() {
    if (!this.formGroup.controls["PrintDisplayOrder"].value) this.formGroup.controls["PrintDisplayOrder"].setValue(0);
  }
  setMaxCode() {
    this.httpCommonService
      .getMaxCode(this.apiName)
      .pipe(take(1))
      .subscribe((data) => {
        if (!this.model) this.model = <ItemCategory>{};
        if (data) {
          this.model["Code"] = data as number;
        }
        this.setFormGroup(this.model);
      });
  }
  setColumnAttribute() {
    super.setColumnAttribute();
    if (!this.orignalColumns.some((s) => s.name === "SetImage")) {
      const addBtn = new form_control();
      addBtn.name = "SetImage";
      addBtn.label = this.translate("ClientApp.FrontOffice.Catalog.ItemCategory.SelectImage");
      addBtn.formVisible = true;
      addBtn.userClass = "open-images-btn";
      addBtn.buttonIcon = "icon-add_photo_alternate-o";
      addBtn.columnNumber = 1;
      addBtn.order = 1;
      addBtn.controlType = FormControlTypes.Button;
      this.orignalColumns.push(addBtn);
    }
    this.orignalColumns.forEach((x) => {
      const info = this.accountService.authService.currentInformation();
      if (x.name === "DetailLedgerId")
        x.formVisible =
          info.AccountingKind === SoftWareLicenseKind.AccountingAdvancedWeb ||
          info.AccountingKind === SoftWareLicenseKind.AccountingToAdvancedWeb ||
          info.AccountingKind === SoftWareLicenseKind.AccountingWeb;
      if (x.name === "GoodsId")
        x.formVisible =
          info.InventoryKind === SoftWareLicenseKind.InventoryWeb ||
          info.InventoryKind === SoftWareLicenseKind.InventoryAdvancedWeb ||
          info.InventoryKind === SoftWareLicenseKind.InventoryToAdvancedWeb;

      if (info.HasProtel) {
        if (x.name === "ProtelCode") {
          x.formVisible = true;
        }
      }
    });
    this.columns = this.orignalColumns.filter(
      (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
    );
    this.columns = this.columns.sort((a, b) => a.order - b.order);
  }
  // چک کردن انتقال اطلاعات مدیریت شعب
  async FillData() {
    const info = this.accountService.authService.currentInformation();
    if (info.BranchingLightEnabled || info.BranchingAdvancedEnabled) {
      const hasBranchCommunication = JSON.parse(localStorage.getItem("HasBranchCommunication"));
      if (hasBranchCommunication == null) {
        this.httpCommonService
          .getList(`Branch/HasBranchCommunication/${this.accountService.authService.currentBranchId}`)
          .pipe(take(1))
          .subscribe(
            async (hbc: boolean) => {
              if (hbc === true) {
                this.sts.showDialog(
                  this.translate("ClientApp.FrontOffice.Catalog.ItemCategory.HasBranchCommunication"),
                  this.translate("ClientApp.FrontOffice.Catalog.Item.Attention")
                );
                this.deactivateSave = true;
              }
            },
            (error) => this.getFailedHelper(error)
          );
      } else if (hasBranchCommunication) {
        this.sts.showDialog(
          this.translate("ClientApp.FrontOffice.Catalog.ItemCategory.HasCallCenterCommunication"),
          this.translate("ClientApp.FrontOffice.Catalog.Item.Attention")
        );
        this.deactivateSave = true;
      }
    }
  }
  onDynamicFormChanges(controlName) {
    if (controlName === "SetImage") {
      this.openImagesForm();
    }
  }
}
